import React, { useEffect, useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const OPTIONS = [50, 100, 150, 200, 250];

export function usePageSize(defaultSize = 50) {
  const [pageSize, setPageSize] = useState(defaultSize);
  const [page, setPage] = useState(0);
  return { pageSize, setPageSize, page, setPage };
}

export function RowsPerPage({ pageSize, onChange, testid = "rows-per-page-select" }) {
  return (
    <div className="flex items-center gap-2" data-testid={`${testid}-wrap`}>
      <span className="text-[11px] text-slate-500 hidden sm:inline">Tampilkan</span>
      <Select value={String(pageSize)} onValueChange={(v) => onChange(Number(v))}>
        <SelectTrigger className="h-8 w-[90px] text-xs" data-testid={testid}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {OPTIONS.map(o => <SelectItem key={o} value={String(o)}>{o} / hlm</SelectItem>)}
        </SelectContent>
      </Select>
    </div>
  );
}

export function usePaginated(rows, defaultSize = 50) {
  const { pageSize, setPageSize, page, setPage } = usePageSize(defaultSize);
  const total = rows?.length || 0;
  // Reset ke halaman 1 saat jumlah baris berubah (mis. saat user mencari/filter)
  useEffect(() => { setPage(0); }, [total]);
  const pages = Math.max(1, Math.ceil(total / pageSize));
  const safePage = Math.min(page, pages - 1);
  const start = safePage * pageSize;
  const paged = (rows || []).slice(start, start + pageSize);
  const pager = total > 0 && (
    <div className="flex items-center justify-between gap-3 px-3 py-2 border-t border-slate-100 bg-slate-50/50" data-testid="pager">
      <span className="text-[11px] text-slate-500">
        Menampilkan <b>{start + 1}–{Math.min(start + pageSize, total)}</b> dari <b>{total}</b> · Halaman {safePage + 1}/{pages}
      </span>
      <div className="flex items-center gap-2">
        <RowsPerPage pageSize={pageSize} onChange={(v) => { setPageSize(v); setPage(0); }} />
        {pages > 1 && (
          <div className="flex gap-1">
            <button
              onClick={() => setPage(Math.max(0, safePage - 1))}
              disabled={safePage === 0}
              className="px-2 h-8 rounded border border-slate-200 text-xs hover:bg-white disabled:opacity-40"
              data-testid="pager-prev"
            >‹ Prev</button>
            <button
              onClick={() => setPage(Math.min(pages - 1, safePage + 1))}
              disabled={safePage >= pages - 1}
              className="px-2 h-8 rounded border border-slate-200 text-xs hover:bg-white disabled:opacity-40"
              data-testid="pager-next"
            >Next ›</button>
          </div>
        )}
      </div>
    </div>
  );
  return { paged, pager, total, pageSize, setPageSize, page: safePage, setPage };
}
